import api from '../../utils/api';
import { alertError, alertSuccess } from './alert';
import { putPermissions, setReplenishShipperAccount } from './permissions';
import { getSupplierRetailer, getSupplierWarehouses } from './api/suppliers';
import { CURRENT_RETAILER_TERMS } from '../constants/permissionsTypes';
import {
  CURRENT_RETAILER,
  CURRENT_RETAILER_LOADING,
  CURRENT_RETAILER_TAB,
  CURRENT_RETAILER_UPDATE,
  CURRENT_RETAILER_WAREHOUSES,
} from '../constants/retailerTypes';

const setRetailerLoading = (value) => ({ type: CURRENT_RETAILER_LOADING, payload: value });
const setRetailerWarehouses = (data) => ({ type: CURRENT_RETAILER_WAREHOUSES, payload: data });

export const setRetailer = (value) => ({ type: CURRENT_RETAILER, payload: value });
export const updateRetailer = (value) => ({ type: CURRENT_RETAILER_UPDATE, payload: value });
export const setRetailerTab = (tab) => ({ type: CURRENT_RETAILER_TAB, payload: tab });

export const setRetailerTerms = (retailerTerms) => {
  retailerTerms.replenishment_order_shipping_cost_percentage =
    retailerTerms.replenishment_order_shipping_cost[0].percentage;
  retailerTerms.replenishment_order_shipping_cost_fixed_per_unit =
    retailerTerms.replenishment_order_shipping_cost[0].fixed_per_unit;
  delete retailerTerms.replenishment_order_shipping_cost;

  return {
    type: CURRENT_RETAILER_TERMS,
    payload: retailerTerms,
  };
};

export const getRetailer = (retailerId) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  dispatch(setRetailerLoading(true));

  try {
    const response = await getSupplierRetailer(supplierId, retailerId);
    dispatch(setRetailer(response.data));
    dispatch(setRetailerTerms(response.data));

    const warehousesResponse = await getSupplierWarehouses(supplierId);
    if (warehousesResponse.data) {
      const warehouses = warehousesResponse.data
        .filter((warehouse) => warehouse.is_enabled)
        .map((warehouse) => ({
          id: warehouse.id,
          name: warehouse.name,
        }));

      dispatch(setRetailerWarehouses(warehouses));
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setRetailerLoading(false));
  }
};

export const postRetailerErpId = (data, storeId) => async (dispatch, getState) => {
  const { supplierId } = getState().role;
  try {
    const response = await putErpId(data, supplierId, storeId);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const updateShipperAccount = (data) => async (dispatch, getState) => {
  const { current } = getState().retailer;
  const permissions = {
    replenishment_shipper_account_type: data.carrier,
    replenishment_shipper_account: data.account,
  };

  try {
    dispatch(setReplenishShipperAccount(data.carrier, data.account));
    dispatch(putPermissions(current.retailer_id, permissions));
  } catch (error) {
    dispatch(alertError(error));
  }
};

let cancelPutErpId;
const putErpId = (data, supplierId, storeId) => {
  if (cancelPutErpId) {
    cancelPutErpId('Cancel retailer put erp id');
  }

  return api.put(`/suppliers/${supplierId}/stores/${storeId}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelPutErpId = c)),
  });
};
